import { UseToastOptions } from '@chakra-ui/react';

export const problemCompletingRequest: UseToastOptions = {
  title: 'There was a problem completing your request',
  status: 'error',
  position: 'top',
  duration: 5000,
};

export const fileArchiveSuccess: UseToastOptions = {
  title: 'File archived',
  status: 'success',
  position: 'bottom',
  duration: 5000,
};

export const fileDeleteSuccess: UseToastOptions = {
  title: 'File deleted',
  status: 'success',
  position: 'bottom',
  duration: 5000,
};

export const unexpectedErrorToastOpts: UseToastOptions = {
  title: 'Unexpected error',
  description:
    'We were unable to create your new folder, we have logged an error.',
  status: 'error',
  position: 'top',
  isClosable: true,
  duration: 8000,
};
